import styled from '@emotion/styled/macro';
import { Variables } from '@enter/core';

export const Wrapper = styled.div`
    display: flex;
    flex-grow: 1;
`;

export const Chart = styled.svg`
    color: ${Variables.Colors.n100};
`;

export const Error = styled.div`
    flex-grow: 1;
`;
